import L from 'leaflet';
import 'leaflet-velocity-ts';
import {MapLayer} from 'react-leaflet';
import {getRefTime} from '../../utils/wind_utils';

class VelocityLayer extends MapLayer {
  _createLayer(data) {
    return L.velocityLayer({
      displayValues: false,
      data: data,
      velocityScale: 0.005,    // modifier for particle animations, arbitrarily defaults to 0.005
      colorScale: ['#555']          // define your own array of hex/rgb colors
    });
  }

  createLeafletElement(props) {
    return this._createLayer(props.data);
  }

  updateLeafletElement(oldProps, newProps) {
    const oldTime = getRefTime(oldProps.data);
    const newTime = getRefTime(newProps.data);
    if (oldTime && newTime && oldTime !== newTime) {
      return this._createLayer(newProps.data);
    }
  }
}

export default VelocityLayer;


// WEBPACK FOOTER //
// ./src/components/leaflet/VelocityLayer.js